/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { MessagingOption } from 'cio/pods/setup-guide/create-campaign/controller';
import AnalyticsService from 'cio/services/analytics';

interface SetupGuideCreateCampaignOptionArgs {
  option: MessagingOption;
  selectedCampaign?: MessagingOption;
  isCreating: boolean;
  name: string;
  onNameChange: (value: string) => unknown;
  selectCampaign: (option: MessagingOption) => unknown;
  selectAndCreateCampaign: (option: MessagingOption) => unknown;
}

export default class SetupGuideCreateCampaignOption extends Component<SetupGuideCreateCampaignOptionArgs> {
  @service analytics!: AnalyticsService;

  @tracked isShowingDetails = false;

  @action
  togglePreviewModal() {
    this.isShowingDetails = !this.isShowingDetails;

    if (this.isShowingDetails) {
      this.analytics.track('onboarding', 'preview_sample_campaign_clicked', { model: this.args.option.campaign });
    }
  }
}
